export default __webpack_public_path__ + "static/media/roboto-400-regular.176f8f5b.woff2";